module.exports = __webpack_public_path__ + "static/media/one tower fell.4fd2f891.png";